/**
 * Browser detection utilities for CSS fixes
 * Applies CSS classes to document.body for browser-specific styling
 */

export function applyBrowserClasses() {
  if (typeof document === 'undefined') return
  
  const userAgent = navigator.userAgent
  const body = document.body
  
  // Detect Safari (not Chrome)
  if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    body.classList.add('browser-safari')
  }
  
  // Detect Firefox
  if (userAgent.includes('Firefox')) {
    body.classList.add('browser-firefox')
  }
  
  // Detect Chromium-based browsers (Chrome, Edge, Opera)
  if (userAgent.includes('Chrome') || userAgent.includes('Edg') || userAgent.includes('OPR')) {
    body.classList.add('browser-chromium')
  }
  
  // Detect reduced motion preference for accessibility
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    body.classList.add('prefers-reduced-motion')
  }
}